import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const FooterStyled = styled.div`
  background-color: transparent;
  text-align: center;
  min-height: 3rem;
  padding: ${props => props.theme.padding};
  text-transform: uppercase;
  text-shadow: ${props => props.theme.textShadow};
  font-size: ${props => props.theme.footer.fontSize};
  padding-left: ${props => props.extraIndent ? '35.4rem' : 0};
  a {
    color: ${props => props.theme.primaryColor};
  }

  ${media.small`
    padding-bottom: ${props => props.expand ? props.theme.footer.expand.padding : props.theme.padding};
    padding-left: 0;
  `};
`;

export const FooterDot = styled.span`
  padding: 0 ${props => props.theme.footer.dotPadding};
  ::before {
    content: '\\00b7';
  }
`;

export const FooditLogo = styled.img`
  background-color: ${props => props.theme.primaryBackground};
  height: 1.9rem;
  max-width: 100%;
  vertical-align: middle;
`;

export const FooterPoweredBy = styled.p`
  text-transform: none;
  font-style: italic;
  margin: 0;
  letter-spacing: 1px;
`;



// WEBPACK FOOTER //
// ./components/Footer/Footer.style.js